import React, { FunctionComponent } from 'react';
import { Page } from 'b302-frontend-library';
import UniversityFormPage from '../../../partials/UniversityFormPage';

interface Props {}

const NewUniversity: FunctionComponent<Props> = () => {

    return (
        <Page className={'new-university-page'}>
            <UniversityFormPage />
        </Page>
    );
};

export default NewUniversity;
